module.exports = __webpack_public_path__ + "img/迭代_还原.b4fb0a7b.svg";